import { Injectable } from '@angular/core';
import { ErrorResponse, RestService} from './lib/RestService';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
//import { ConsultService } from './consult.service';

export type SocialProvider = 'vk' | 'instagram' | 'youTube' | 'articles' | 'twitter' | 'tiktok';

export interface SocialPost {
  name: string;
  date: string;
  text: string;
  image: string;
  href: string;
}

@Injectable()
export class SocialService extends RestService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
    super();
  }

  getPosts(provider: SocialProvider, count?: string): Promise<SocialPost[]> {
    if (typeof window === 'undefined') throw new Error('You can not download posts from server');

    let result: any;
    switch (provider) {
      case 'vk':
        result = this.getVkPosts(count);
        break;

      case 'instagram':
        result = this.getInstagramPosts(count);
        break;

      case 'tiktok':
        result = this.getTiktokPosts(count);
        break;

      case 'youTube':
        result = this.getYouTubePosts(count);
        break;

      case 'articles':
        result = this.getWikiPosts(count);
        break;

      case 'twitter':
        result = this.getTwitterPosts(count);
        break;

      default:
        break;
    }

    return result;
  }

  getSubscribeLink(provider: string): string {
    let res = '';
    switch (provider) {
      case 'vk':
        res = 'https://vk.com/zolotoykod';
        break;

      case 'instagram':
        res = 'https://instagram.com/zolotoy_kod';
        break;

      case 'youTube':
        res = 'https://www.youtube.com/user/zolotoykodhoreca/videos';
        break;

      case 'articles':
        res = `//wiki/`;
        break;

      case 'twitter':
        res = 'https://twitter.com/zolotoykod';
        break;

      case 'tiktok':
        res = 'https://www.tiktok.com/@it.fix';
        break;

      default:
        break;
    }
    return res;
  }

  /**
   * VK
   */
  public async getVkPosts(
    count = '2',
    domain = 'zolotoykod',
    extended = '1',
    v = '5.64'
  ) {
    const url = `https://api.vk.com/method/wall.get`
      + `?v=${v}`
      + `&domain=${domain}`
      + `&count=${count}`
      + `&extended=${extended}`
      + `&access_token=295a9678163405c12e01b23a62929b737bf34f1590e806a238bfac357c5fb37133e2784ac039a71688c41`
      + `&callback=JSONP_CALLBACK`
    ;

    try {
      const data = await this.http.jsonp<any>(url, 'JSONP_CALLBACK').toPromise();
      return this.vkNormalize(data);
    } catch (e) {
      this.handleError(e);
      return [];
    }
  }

  private vkNormalize(data: any): SocialPost[] {
    return data.response.items.map((i: any) => {
      const res: SocialPost = {
        name: data.response.groups[0].name,
        date: new Date(i.date * 1000).toDateString(),
        text: i.text || (i.copy_history ? i.copy_history[0].text : ''),
        image: this.vkGetImage(i.attachments ? i.attachments[0] : i.copy_history[0].attachments[0], data.response.groups[0].photo_100),
        href: `https://vk.com/${data.response.groups[0].screen_name}?w=wall-${-1 * i.owner_id}_${i.id}`
      };

      if (res.text.length > 90) res.text = res.text.substr(0, 90) + '...';

      return res;
    });
  }

  private vkGetImage(attachment: any, defaultImg: string): string {
    if (!attachment) return defaultImg;
    if (attachment.type === 'video') return attachment.video.photo_130;
    if (attachment.type === 'photo') return attachment.photo.photo_130;
    if (attachment.type === 'album') return attachment.album.thumb.photo_130;
    return defaultImg;
  }

  /**
   * TikTok
   */

  public async getTiktokPosts(
    count = '2', 
    user = 'it.fix',
    domain = "https://shop.zolotoykod.ru"
  ) {
    const url = domain + ":4000/tiktok?id=" + user;

    try {
      const data = await this.http.get(url).toPromise();
      return this.tiktokNormalize(data, count);
    } catch (res) {
      const err: ErrorResponse = {
        error: {
          code: res.meta.code,
          message: res.meta.error_message
        }
      };
      this.handleError(err);
      return [];
    }
  }
  
  private tiktokNormalize(data: any, count: string): SocialPost[] {
    data = data.slice(0,+count);
    return data;
  }

  /**
   * INSTAGRAM
   */

  public async getInstagramPosts(
    count = '2', 
    user = 'zolotoy_kod',
    domain = "https://shop.zolotoykod.ru"
  ) {
    const url = domain + ":4000/inst?id=" + user;

    try {
      const data = await this.http.get(url).toPromise();
      return this.instagramNormalize(data, count);
    } catch (res) {
      const err: ErrorResponse = {
        error: {
          code: res.meta.code,
          message: res.meta.error_message
        }
      };
      this.handleError(err);
      return [];
    }
  }

  private instagramNormalize(data: any, count:string): SocialPost[] {
    data = data.slice(0,+count);
    return data;
  }

  /**
   * YOUTUBE
   */
  public async getYouTubePosts(
    count = '2',
    channelId = 'UClol6nLJa4kFPE4Ja_qTteA',
    domain = "https://shop.zolotoykod.ru"
  ) {
    const url = domain + ":4000/youtube?id=" + channelId;

    try {
      const data = await this.http.get(url).toPromise();
      return this.youTubeNormalize(data, count);
    } catch (res) {
      const err: ErrorResponse = {
        error: {
          code: res.meta.code,
          message: res.meta.error_message
        }
      };
      this.handleError(err);
      return [];
    }
  }

  private youTubeNormalize(data: any, count:string): SocialPost[] {
    data = data.slice(0,+count);
    return data;
  }

  /**
   * TWITTER
   */
  public async getTwitterPosts(count = '2') {
    const url = `${this.apiUrl}twitter`;

    try {
      const data = await this.http.get(url, { withCredentials: true }).toPromise();
      return this.twitterNormalize(data);
    } catch (e) {
      this.handleError(e);
      return [];
    }
  }

  private twitterNormalize(data: any): SocialPost[] {
    return data.map((i: any) => {
      const res: SocialPost = {
        name: i.user.name,
        date: i.created_at,
        text: i.text,
        image: i.user.profile_image_url.replace('normal', '200x200'),
        href: `https://twitter.com/${i.user.screen_name}/status/${i.id_str}`
      };

      if (res.text.length > 90) res.text = res.text.substr(0, 90) + '...';

      return res;
    });
  }

  /**
   * WIKI
   */
  public getWikiPosts(count = '2') {
    // TODO: use API
    return new Promise((resolve, reject) => {
      resolve([
        {
          name: 'Название статьи',
          date: '2017-06-20T21:26:10.000Z',
          text: 'Иван Иванов',
          image: '/assets/img/vk-news.jpg',
          href: '#'
        },
        {
          name: 'Название статьи',
          date: '2017-06-20T21:26:10.000Z',
          text: 'Иван Иванов',
          image: '/assets/img/vk-news.jpg',
          href: '#'
        }
      ]);
    });
  }

  private wikiNormalize(data: any): SocialPost[] {
    return data.items.map((i: any) => {
      const res: SocialPost = {
        name: i.snippet.title,
        date: i.snippet.publishedAt,
        text: i.snippet.description,
        image: i.snippet.thumbnails.medium.url,
        href: '#'
      };

      if (res.text.length > 90) res.text = res.text.substr(0, 90) + '...';

      return res;
    });
  }
}
